var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader?presets[]=es2015&cacheDirectory=true&sourceMap=true!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./bo-list-item.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-7cd8a2c4\"}!./bo-list-item.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./scripts/bo-list/bo-list-item.vue
// module id = 254
// module chunks = 1